import Vue from 'vue'

const state = () => {
  return {
    selected: {},
    list: [] 
  }
}

const getters = {
  selected: state => {
    let integration = state.list.find(integration => integration.type === state.selected.type)    
    return integration
  }
}

const mutations = {
  SELECT_INTEGRATION (state, integration) {    
    state.selected = integration
  },  
  SET_INTEGRATIONS (state, integrations) {
    state.list = [...integrations]
  },
}

const actions = {
    async getIntegrations ({ state, commit }) {
        try {
          let { data } = await Vue.axios.get(`integrations`)
          commit('SET_INTEGRATIONS', data)
          return data
        } catch (error) {
          console.log(error)
        }      
      },

    async getIntegration ({ state, commit }, type) {
        try {
          let { data } = await Vue.axios.get(`integration/${type}`)
          commit('SELECT_INTEGRATION', data)
          return data
        } catch (error) {
          console.log(error)
        }      
      },
    
    async putIntegrationConfiguration ({ state, commit}, {type, configuration}) {
        try {
            let { data } = await Vue.axios.put(`integration/${type}/configuration`, configuration)
            commit('SELECT_INTEGRATION', data)
            return data
          } catch (error) {
            console.log(error)
          }   
    },

    async deleteIntegration ({ state, commit}, type) {
        try {
            let { data } = await Vue.axios.delete(`integration/${type}`)
            commit('SELECT_INTEGRATION', data)
            return data
          } catch (error) {
            console.log(error)
          }   
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
